import React from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  keyframes,
} from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { AppButton } from '../StyledComponent';

const checkmarkAnimation = keyframes`
  0% {
    stroke-dashoffset: 25;
  }
  100% {
    stroke-dashoffset: 0;
  }
`;

const popInAnimation = keyframes`
  0% {
    transform: scale(0.7);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const SuccessDialog = ({ open, onClose, title, children }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "15px",
          padding: 1,
          width: "100%",
          maxWidth: 400,
        },
      }}
    >
      <DialogContent sx={{ textAlign: "center" }}>
        <CheckCircleRoundedIcon
          sx={{
            color: "success.main",
            fontSize: 60,
            animation: `${popInAnimation} 0.4s ease-out`,
          }}
        />
        <Typography variant="h5" sx={{ fontWeight: 500, mb: 1 }}>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {children}
        </Typography>
        <Box sx={{ mt: 4 }}>
          <AppButton
            variant="contained"
            onClick={onClose}
            // fullWidth
            sx={{width:"40%"}}
            size="large"
          >
            Done
          </AppButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessDialog; 